import axios from "axios";
//const baseURL = 'https://idyllic-granita-9fe36e.netlify.app/.netlify/functions/app'
const baseURL = 'https://idyllic-granita-9fe36e.netlify.app/.netlify/functions/app'
export default axios.create({
    baseURL
})

export const axiosIntercepter = axios.create({
    baseURL,
    headers:{
        "Content-Type":'application/json'
    },
    withCredentials:true
})